<template>
  <div >
    <el-dialog :visible.sync="dialogVisible" width="53%" :show-close="false" class="createProductDialog"
      :append-to-body="true">
      <div class="title">
        <p>生成参考酒店</p>
      </div>
      <div class="content">
        <div v-for="(item,index) in stockObj" :key="index">
          <span v-if="item.startDate" style="width:2rem">{{item.startDate}}至{{item.endDate}}</span>
          <span style="width:1.5rem">{{item.productNameCn}}</span>
          <span>销售价格</span>
          <el-input v-model="item.salePrice" size="mini"></el-input>
          <span>option时间</span>
          <el-date-picker v-model="item.optionDate" format="yyyy-MM-dd HH" type="datetime" placeholder="选择日期时间" style="width: 1.7rem;"/>
        </div>
        <div>
          <el-button @click="save">保存并加入行程轴</el-button>
          <el-button @click="dialogVisible=false">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
export default {
  data(){
    return{
      dialogVisible:false,
      resourceObj:{},
      stockObj:[],
      chenckBudgteObj:{}
    }
  },
  methods:{
    beforeOpen(item,item1,data){
      this.dialogVisible = true;
      this.resourceObj = item
      this.stockObj = item1
      this.stockObj.forEach(e=>{
        this.$set(e,'salePrice',null)
      })
      this.chenckBudgteObj = data
    },
    save(){
      var arr = []
      this.stockObj.forEach(e=>{
        arr.push({
          stockId:e.stockId,
          stockNumber:e.checkNumber,
          ratio:e.salePrice,
          optionDate:e.optionDate,
        })
      })
      var obj = {
        budgetMainId:this.chenckBudgteObj.id,
        planId:this.chenckBudgteObj.planId,
        state:0,
        startLinkId:this.resourceObj.cityId,
        startLinkName:this.resourceObj.cityNameCn,
        startLinkNameEn:this.resourceObj.cityNameEn,
        linkType:1,
        productType:this.resourceObj.productType,
        resourceId:this.resourceObj.id,
        resourceNameCn:this.resourceObj.nameCn,
        resourceNameEn:this.resourceObj.nameEn,
        key:this.resourceObj.productType==3||this.resourceObj.productType==2?this.keyStr:this.climbKey,
        details:arr
      }
      new PlanApi('plan').addBudgetRefer(obj).then(res => {
        if (res.status == 200) {
          this.dialogVisible = false;
          this.$message({type:"success",message:"添加成功"})
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
  },
  props:{
    keyStr:{
      type:String,
      default:''
    },
    climbKey:{
      type:String,
      default:''
    }
  }
}
</script>

<style lang="scss" scoped>
.createProductDialog{
  /deep/ .el-dialog__body,/deep/ .el-dialog__header{
    padding: 0 !important;
  }
  .title{
    background: #e1f5f3;
    padding: 0.12rem 0.4rem;
    font-weight: bold;
    color: black;
    >p:first-child{
      font-size: 0.18rem;
      margin-bottom: 0.05rem;
    }
  }
  .content{
    color: black;
    padding: 0.1rem 0.6rem;
    >div:last-child{
      justify-content: center;
      margin-top: 0.2rem;
      >button{
        background: #E1F5F3;
        color: #148276;
      }
    }
    >div{
      margin-top: 0.1rem;
      display: flex;
      align-items: center;
      >div{
        width: 1.2rem;
        margin-right:0.1rem;
      }
      >span{
        margin-right:0.1rem;
      }
    }
  }
}
</style>